import * as React from 'react';

const AdobeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={28} viewBox="0 0 29 28" width={29} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M0.137329 10.1333C0.137329 6.58633 0.137329 4.81283 0.827619 3.45806C1.43482 
            2.26637 2.4037 1.29749 3.59539 0.69029C4.95016 0 6.72366 0 10.2706 0H18.004C21.551
            0 23.3245 0 24.6792 0.69029C25.8709 1.29749 26.8398 2.26637 27.447 3.45806C28.1373 
            4.81283 28.1373 6.58633 28.1373 10.1333V17.8667C28.1373 21.4137 28.1373 23.1872
            27.447 24.5419C26.8398 25.7336 25.8709 26.7025 24.6792 27.3097C23.3245 28 21.551 28 
            18.004 28H10.2706C6.72366 28 4.95016 28 3.59539 27.3097C2.4037 26.7025 1.43482 25.7336
            0.827619 24.5419C0.137329 23.1872 0.137329 21.4137 0.137329 17.8667V10.1333Z"
            fill="white"
        />
        <path
            d="M13.7059 17.5961H9.36703L8.48423 20.4088C8.45973 20.5133 8.36353 20.5873 8.25883 
            20.5821H6.06117C5.93584 20.5821 5.89202 20.5115 5.92969 20.3702L9.68633 9.27356C9.72393 
            9.15796 9.76153 9.02636 9.79903 8.87866C9.84823 8.62156 9.87333 8.36036 9.87423
            8.09846C9.86343 8.02106 9.93143 7.9527 10.0056 7.96354H12.9922C13.0797 7.96354 
            13.1297 7.99566 13.1424 8.05986L17.4063 20.3895C17.4438 20.518 17.4063 20.5822
            17.2936 20.5821H14.8517C14.7661 20.5919 14.6843 20.5332 14.6639 20.4473L13.7059
            17.5961ZM10.0432 15.1687H13.011C12.5234 13.5025 11.9731 11.8582 11.5271 10.1791C11.0459 
            11.8611 10.5209 13.5363 10.0432 15.1687Z"
            fill="#282B2C"
        />
        <path
            d="M19.9419 10.0058C19.7503 10.0137 19.5593 9.98 19.3812 9.907C19.2032 9.834 19.0422 
            9.7232 18.9088 9.582C18.7758 9.4346 18.6724 9.2618 18.6047 9.0733C18.537 8.8849 
            18.5063 8.6846 18.5143 8.4839C18.5075 8.2852 18.5416 8.0873 18.6144 7.90305C18.6873 
            7.71881 18.7972 7.5524 18.937 7.41468C19.0754 7.27839 19.2388 7.17161 19.4178 
            7.10052C19.5967 7.02942 19.7876 6.99543 19.9794 7.00049C20.4303 7.00049 20.784 
            7.13856 21.0407 7.41468C21.1703 7.55818 21.271 7.72648 21.3371 7.90995C21.4031 
            8.0934 21.4333 8.2885 21.4257 8.4839C21.4336 8.6853 21.4019 8.8864 21.3325
            9.075C21.2632 9.2636 21.1575 9.436 21.0219 9.582C20.8802 9.7253 20.711 9.8369 
            20.5252 9.9099C20.3393 9.9828 20.1407 10.0155 19.9419 10.0058ZM18.6458
            20.3896V11.181C18.6458 11.0654 18.6957 11.0076 18.7961 11.0076H21.1065C21.2065 
            11.0076 21.2566 11.0654 21.2567 11.181V20.3896C21.2567 20.5182 21.2066 20.5824 
            21.1065 20.5823H18.8149C18.7022 20.5823 18.6458 20.5181 18.6458 20.3896Z"
            fill="#282B2C"
        />
    </svg>
);
export default AdobeIcon;
